module.exports = __webpack_public_path__ + "static/img/gear.421724c7.png";